<template>
  <div class="overflow-hidden rounded-lg bg-white shadow">
    <div class="px-4 py-5 sm:p-6">
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-base font-semibold leading-6 text-gray-900">User</h1>
          <p class="mt-2 text-sm text-gray-700">Details</p>
        </div>
        <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button @click="cancel" type="button" class="pull-right block rounded-md bg-gray-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">Back</button>
        </div>
      </div>
      <div class="mt-6 border-t border-gray-100">
        <dl class="divide-y divide-gray-100">
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Profile photo</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
              <img :src="user.profile_photo" class="profile-image img img-rounded w-20">
            </dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">ID</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ user.id }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">First Name</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ user.first_name }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Last Name</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ user.last_name }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Email</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ user.email }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Account Name</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0 trix-editor"><span v-html="user.account_name"></span></dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Created at</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ user.created_at }}</dd>
          </div>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "UserShowComponent",
  data() {
    return {
      user: {
        id: null,
        first_name: null,
        last_name: null,
        email: null,
        account_name: null,
        created_at: null,
        profile_photo: null,
      }
    }
  },
  computed: {
    userId() {
      return this.$route.params.id ? parseInt((this.$route.params.id)) : null;
    },
  },
  methods: {
    getUser() {
      axios.get(`/member-firm/users/show/${this.userId}`).then((res) => {
        this.user = res.data.data;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    cancel() {
      this.$router.back();
    },
  },
  mounted() {
    if (this.userId) {
      this.getUser();
    }
  }

}
</script>